import { useProfile } from "./UserHooks";

/**
 * Custom hook to check if the current user has required roles
 * @param {string|string[]} requiredRoles - Single role string or array of allowed roles
 * @returns {object} - { hasAccess: boolean, userRoles: string[] }
 */
const useRoleCheck = (requiredRoles) => {
  const { userProfile } = useProfile();

  if (!userProfile) {
    return { hasAccess: false, userRoles: [] };
  }

  // Get user roles from profile (handles different possible structures)
  // Check for associatedRoles array first, then roles array, then single role field
  let userRoles = [];
  
  if (Array.isArray(userProfile.associatedRoles)) {
    userRoles = userProfile.associatedRoles;
  } else if (Array.isArray(userProfile.roles)) {
    userRoles = userProfile.roles;
  } else if (userProfile.role) {
    userRoles = [userProfile.role];
  }

  // Check if user has required role(s)
  const requiredArray = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles];
  const hasAccess = requiredArray.some(role => 
    userRoles.some(userRole => 
      userRole === role || userRole?.name === role
    )
  );

  return { hasAccess, userRoles };
};

export { useRoleCheck };
